import { go } from '@api3/commons';
import { useSwitchChain } from 'wagmi';
import { UserRejectedRequestError } from 'viem';
import { useState } from 'react';
import { allChainsById } from '../../utils/dapis';
import { walletMessages } from '../../constants/walletMessages';
import { useDocumentVisibility } from '../use-document-visibility';
import { useGeneralStore } from '../../stores';
import { getApi3RpcUrls } from '../../utils/utils';
import { ErrorMessage } from '../../types';

export function useSwitchNetwork() {
  const { setChainSwitchStatus } = useGeneralStore();
  const { isTabActive } = useDocumentVisibility();
  const { mutateAsync } = useSwitchChain();
  const [error, setError] = useState<ErrorMessage>();

  const handleSwitch = async (newChainId: number | undefined) => {
    if (!newChainId || !isTabActive) {
      return;
    }

    const newChain = allChainsById[newChainId];

    if (!newChain) {
      setError({
        message: walletMessages.TX_GENERIC_ERROR_MESSAGE,
        secondaryMessage: 'Unsupported chain',
      });
      return;
    }

    // Attempt to switch the chain from the user's MetaMask
    const result = await go(() =>
      mutateAsync({
        chainId: newChainId,
        addEthereumChainParameter: {
          chainName: newChain.name,
          nativeCurrency: {
            name: newChain.name,
            symbol: newChain.symbol,
            decimals: newChain.decimals,
          },
          rpcUrls: getApi3RpcUrls(newChainId),
          blockExplorerUrls: [newChain.blockExplorerUrl],
        },
      })
    );

    if (!result.success) {
      if (result.error instanceof UserRejectedRequestError) {
        return;
      }
    }

    // Chain switched successfully
    if (result.success) {
      setChainSwitchStatus('idle');
      setError(undefined);
      return;
    }

    setError({
      message: walletMessages.TX_GENERIC_ERROR_MESSAGE,
      secondaryMessage: walletMessages.TX_SWITCH_NETWORK,
    });

    setChainSwitchStatus('rejected');
  };

  return {
    switchNetwork: handleSwitch,
    error,
    setError,
  };
}
